export default __webpack_public_path__ + "static/media/b4.0b9a945f.jpg";